<div class="player-container"
     [class.highlighted]="highlight"
     (click)="openPlayerPage()">
    <div class="player-name">{{ player.name }} {{ highlight ? '(You)' : '' }}</div>
    <div class="player-games">{{ gameCount }} game{{ gameCount === 1 ? '' : 's' }}</div>
    <div class="player-date">Created on {{ player.dateCreated | date }}</div>
</div>